import { merge, Stack } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useMemo, useState } from 'react';
import cancelIcon from '../../../assets/icons/svg/cancel.svg';
import padlockRedIcon from '../../../assets/icons/svg/padlockRed.svg';
import saveIcon from '../../../assets/icons/svg/save.svg';
import userRedIcon from '../../../assets/icons/svg/userRed.svg';
import { AccessType, useAuth } from '../../../contexts/authContext';
import { useNotificationsManager } from '../../../contexts/notificationContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { useUser, useUserManager } from '../../../contexts/userContext';
import { Data } from '../../../data/Data';
import Page from '../../Page';
import DropdownSituationActuelle from './DropdownSituationActuelle';
import DropdownSituationCivile from './DropdownSituationCivile';
import FormActionButton from './FormActionButton';
import PasswordForm from './PasswordForm';
import PickerYear from './PickerYear';
import Preferences from './Preferences';
import ProfileDatePicker from './ProfileDatePicker';
import ProfileTextField from './ProfileTextField';

const MonProfil = () => {

    const { accessType } = useAuth();
    const { confirm, dismiss, extractErrorMessages, inform } = useNotificationsManager();
    const { responsiveSize } = useResponsiveSize();
    const { updateUser } = useUserManager();
    const { user } = useUser();

    const {
        // Client
        adresse = "",
        civilite = "",
        complementAdresse = "",
        consentementCollecteDonneesPersonnelles = false,
        consentementDiffusionDonneesPersonnelles = false,
        cp = "",
        email = "",
        loginContact = "",
        nom = "",
        nomDeJeuneFille = "",
        pays = "",
        prenom = "",
        souhaiteRecevoirOffres = false,
        tel1 = "",
        tel2 = "",
        ville = "",

        // Prospect
        dateMariage = "",
        datenaissance = "",
        dateNaissanceEnfant1 = "",
        dateNaissanceEnfant2 = "",
        dateNaissanceEnfant3 = "",
        dateNaissanceEnfant4 = "",
        dateNaissanceEnfant5 = "",
        lieuNaissance = "",
        nationalite = "",
        nomEmployeur = "",
        profession = "",
        revenusAnnuels = "",
        situationActuelle = "",
        situationCivile = ""
    } = user;

    const [isProfileEditionEnabled, { toggle: toggleProfileEdition }] = useBoolean(false);
    const [isPasswordEditionEnabled, { toggle: togglePasswordEdition }] = useBoolean(false);

    // Client
    const [newAdresse, setNewAdresse] = useState(adresse);
    const [newComplementAdresse, setNewComplementAdresse] = useState(complementAdresse);
    const [newConsentementDiffusionDonneesPersonnelles, setNewConsentementDiffusionDonneesPersonnelles] = useState(consentementDiffusionDonneesPersonnelles);
    const [newCp, setNewCp] = useState(cp);
    const [newEmail, setNewEmail] = useState(email);
    const [newPays, setNewPays] = useState(pays);
    const [newSouhaiteRecevoirOffres, setNewSouhaiteRecevoirOffres] = useState(souhaiteRecevoirOffres);
    const [newTel1, setNewTel1] = useState(tel1);
    const [newTel2, setNewTel2] = useState(tel2);
    const [newVille, setNewVille] = useState(ville);

    // Prospect
    const [newConsentementCollecteDonneesPersonnelles, setNewConsentementCollecteDonneesPersonnelles] = useState(consentementCollecteDonneesPersonnelles);
    const [newDateMariage, setNewDateMariage] = useState(dateMariage);
    const [newDateNaissance, setNewDateNaissance] = useState(datenaissance);
    const [newDateNaissanceEnfant1, setNewDateNaissanceEnfant1] = useState(dateNaissanceEnfant1);
    const [newDateNaissanceEnfant2, setNewDateNaissanceEnfant2] = useState(dateNaissanceEnfant2);
    const [newDateNaissanceEnfant3, setNewDateNaissanceEnfant3] = useState(dateNaissanceEnfant3);
    const [newDateNaissanceEnfant4, setNewDateNaissanceEnfant4] = useState(dateNaissanceEnfant4);
    const [newDateNaissanceEnfant5, setNewDateNaissanceEnfant5] = useState(dateNaissanceEnfant5);
    const [newLieuNaissance, setNewLieuNaissance] = useState(lieuNaissance);
    const [newNationalite, setNewNationalite] = useState(nationalite);
    const [newNomEmployeur, setNewNomEmployeur] = useState(nomEmployeur);
    const [newProfession, setNewProfession] = useState(profession);
    const [newRevenusAnnuels, setNewRevenusAnnuels] = useState(revenusAnnuels);
    const [newSituationActuelle, setNewSituationActuelle] = useState(situationActuelle);
    const [newSituationCivile, setNewSituationCivile] = useState(situationCivile);

    const [anneesNaissancesEnfants, setAnneesNaissancesEnfants] = useState([]);

    useEffect(() => {
        setNewAdresse(adresse);
        setNewComplementAdresse(complementAdresse);
        setNewConsentementCollecteDonneesPersonnelles(consentementCollecteDonneesPersonnelles);
        setNewConsentementDiffusionDonneesPersonnelles(consentementDiffusionDonneesPersonnelles);
        setNewCp(cp);
        setNewEmail(email);
        setNewPays(pays);
        setNewSouhaiteRecevoirOffres(souhaiteRecevoirOffres);
        setNewTel1(tel1);
        setNewTel2(tel2);
        setNewVille(ville);
    }, [isProfileEditionEnabled, adresse, civilite, complementAdresse, consentementCollecteDonneesPersonnelles, consentementDiffusionDonneesPersonnelles, cp, email, loginContact, nom, nomDeJeuneFille, pays, prenom, souhaiteRecevoirOffres, tel1, tel2, ville]);

    useEffect(() => {
        let newAnneesNaissancesEnfants = [];
        if (!!newDateNaissanceEnfant1) newAnneesNaissancesEnfants.push(new Date(newDateNaissanceEnfant1).getFullYear());
        if (!!newDateNaissanceEnfant2) newAnneesNaissancesEnfants.push(new Date(newDateNaissanceEnfant2).getFullYear());
        if (!!newDateNaissanceEnfant3) newAnneesNaissancesEnfants.push(new Date(newDateNaissanceEnfant3).getFullYear());
        if (!!newDateNaissanceEnfant4) newAnneesNaissancesEnfants.push(new Date(newDateNaissanceEnfant4).getFullYear());
        if (!!newDateNaissanceEnfant5) newAnneesNaissancesEnfants.push(new Date(newDateNaissanceEnfant5).getFullYear());
        setAnneesNaissancesEnfants(newAnneesNaissancesEnfants);
    }, [newDateNaissanceEnfant1, newDateNaissanceEnfant2, newDateNaissanceEnfant3, newDateNaissanceEnfant4, newDateNaissanceEnfant5]);

    const styles = useMemo(
        () => {
            let styles = {
                buttons: {
                    root: {
                        flexDirection: "column",
                        gap: 13
                    }
                },
                column: {
                    root: {
                        gap: 3,
                        flexBasis: 1,
                        flexGrow: 1,
                    }
                },
                fields: {
                    root: {
                        flexDirection: "column",
                        gap: 3
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        buttons: {
                            root: {
                                flexBasis: 1,
                                flexDirection: "row",
                                flexGrow: 1,
                            }
                        },
                        fields: {
                            root: {
                                flexBasis: 1,
                                flexDirection: "row",
                                flexGrow: 1,
                                gap: "0 5%"
                            }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    const fieldsCommunsA = [
        {
            id: "tfCivilite",
            isEditionAllowed: false,
            key: "civilite",
            label: "civilité :",
            value: civilite
        },
        {
            id: "tfNom",
            isEditionAllowed: false,
            key: "nom",
            label: "nom :",
            value: nom
        },
        {
            id: "tfNomDeJeuneFille",
            isEditionAllowed: false,
            key: "nomDeJeuneFille",
            label: "nom de jeune fille :",
            value: nomDeJeuneFille
        },
        {
            id: "tfPrenom",
            isEditionAllowed: false,
            key: "prenom",
            label: "prénom :",
            value: prenom
        },
        {
            id: "tfLoginContact",
            isEditionAllowed: false,
            key: "loginContact",
            label: "mon login :",
            value: loginContact
        },
        {
            id: "tfTel1",
            isEditionAllowed: true,
            key: "tel1",
            label: "tél. mobile :",
            onChange: (event, newValue) => setNewTel1(newValue),
            value: newTel1
        },
        {
            id: "tfTel2",
            isEditionAllowed: true,
            key: "tel2",
            label: "tél. domicile :",
            onChange: (event, newValue) => setNewTel2(newValue),
            value: newTel2
        },
    ];

    const fieldsCommunsB = [
        {
            id: "tfEmail",
            isEditionAllowed: true,
            key: "email",
            label: "email :",
            onChange: (event, newValue) => setNewEmail(newValue),
            value: newEmail
        },
        {
            id: "tfAdresse",
            isEditionAllowed: true,
            key: "adresse",
            label: "adresse :",
            onChange: (event, newValue) => setNewAdresse(newValue),
            value: newAdresse
        },
        {
            id: "tfComplementAdresse",
            isEditionAllowed: true,
            key: "complementAdresse",
            label: "complément d'adresse :",
            onChange: (event, newValue) => setNewComplementAdresse(newValue),
            value: newComplementAdresse
        },
        {
            id: "tfCp",
            isEditionAllowed: true,
            key: "cp",
            label: "code postal :",
            onChange: (event, newValue) => setNewCp(newValue),
            value: newCp
        },
        {
            id: "tfVille",
            isEditionAllowed: true,
            key: "ville",
            label: "ville :",
            onChange: (event, newValue) => setNewVille(newValue),
            value: newVille
        },
        {
            id: "tfPays",
            isEditionAllowed: true,
            key: "pays",
            label: "pays :",
            onChange: (event, newValue) => setNewPays(newValue),
            value: newPays
        }
    ];

    const fieldsProspect = [
        {
            id: "tfNationalite",
            isEditionAllowed: true,
            key: "nationalite",
            label: "nationalité :",
            onChange: (event, newValue) => setNewNationalite(newValue),
            value: newNationalite
        },
        {
            id: "dpDateMariage",
            isEditionAllowed: true,
            key: "datenaissance",
            label: "date de naissance :",
            onSelectDate: (date) => setNewDateNaissance(date),
            value: newDateNaissance
        },
        {
            id: "tfLieuNaissance",
            isEditionAllowed: true,
            key: "lieuNaissance",
            label: "lieu de naissance :",
            onChange: (event, newValue) => setNewLieuNaissance(newValue),
            value: newLieuNaissance
        },
        {
            id: "dpDateMariage",
            isEditionAllowed: true,
            key: "dateMariage",
            label: "date de mariage :",
            onSelectDate: (date) => setNewDateMariage(date),
            value: newDateMariage
        },
        {
            isEditionAllowed: true,
            key: "anneesNaissancesEnfants",
            label: "années de naissances des enfants :",
            onChange: (years) => {
                setNewDateNaissanceEnfant1(years[0] ? new Date(years[0], 1, 1) : null);
                setNewDateNaissanceEnfant2(years[1] ? new Date(years[1], 1, 1) : null);
                setNewDateNaissanceEnfant3(years[2] ? new Date(years[2], 1, 1) : null);
                setNewDateNaissanceEnfant4(years[3] ? new Date(years[3], 1, 1) : null);
                setNewDateNaissanceEnfant5(years[4] ? new Date(years[4], 1, 1) : null);
            }
        },
        {
            id: "tfProfession",
            isEditionAllowed: true,
            key: "profession",
            label: "profession :",
            onChange: (event, newValue) => setNewProfession(newValue),
            value: newProfession
        },
        {
            id: "tfNomEmployeur",
            isEditionAllowed: true,
            key: "nomEmployeur",
            label: "nom employeur :",
            onChange: (event, newValue) => setNewNomEmployeur(newValue),
            value: newNomEmployeur
        },
        {
            id: "tfRevenusAnnuels",
            isEditionAllowed: true,
            key: "revenusAnnuels",
            label: "revenus annuels :",
            onChange: (event, newValue) => setNewRevenusAnnuels(newValue),
            value: newRevenusAnnuels
        },
        {
            id: "tfSituationActuelle",
            isEditionAllowed: true,
            key: "situationActuelle",
            label: "situation actuelle :",
            onChange: (event, option) => setNewSituationActuelle(option.key),
            value: newSituationActuelle
        },
        {
            id: "tfSituationCivile",
            isEditionAllowed: true,
            key: "situationCivile",
            label: "situation civile :",
            onChange: (event, option) => setNewSituationCivile(option.key),
            value: newSituationCivile
        },
    ];

    const fieldsLeftCol = accessType >= AccessType.restricted
        ? fieldsCommunsA
        : [...fieldsCommunsA, ...fieldsCommunsB];

    const fieldsRightCol = accessType >= AccessType.restricted
        ? fieldsCommunsB
        : fieldsProspect;

    const saveProfile = () => {
        const id = inform("Mise à jour du profil en cours...");

        let contact = {
            adresse: newAdresse,
            complementAdresse: newComplementAdresse,
            consentementCollecteDonneesPersonnelles: true, // Pas indispensable, sécurité supplémentaire
            consentementDiffusionDonneesPersonnelles: newConsentementDiffusionDonneesPersonnelles,
            cp: newCp,
            email: newEmail,
            pays: newPays,
            souhaiteRecevoirOffres: newSouhaiteRecevoirOffres,
            tel1: newTel1,
            tel2: newTel2,
            ville: newVille
        }
        if (accessType === AccessType.prospect)
            contact = {
                ...contact,
                consentementCollecteDonneesPersonnelles: newConsentementCollecteDonneesPersonnelles,
                dateMariage,
                datenaissance,
                dateNaissanceEnfant1,
                dateNaissanceEnfant2,
                dateNaissanceEnfant3,
                dateNaissanceEnfant4,
                dateNaissanceEnfant5,
                lieuNaissance,
                nationalite,
                nomEmployeur,
                profession,
                revenusAnnuels,
                situationActuelle,
                situationCivile
            };

        Data._updateProfile(contact).then(response => {
            if (response.codeRetour === 0) {
                updateUser(contact);
                toggleProfileEdition();
                confirm("Mise à jour effectuée avec succès");
            }
            else extractErrorMessages(response);
            dismiss(id);
        });
    };

    const renderField = (field) => {
        const { isEditionAllowed, id, key, label, onChange, onSelectDate, selectedKey, value } = field;
        switch (key) {
            case "dateMariage":
            case "datenaissance":
                return <ProfileDatePicker
                    key={key}
                    datePickerProps={{
                        disabled: !isEditionAllowed || !isProfileEditionEnabled,
                        label,
                        onSelectDate,
                        value
                    }}
                />;
            case "situationActuelle":
                return <DropdownSituationActuelle
                    key={key}
                    dropdownProps={{
                        disabled: !isEditionAllowed || !isProfileEditionEnabled,
                        onChange,
                        selectedKey
                    }}
                />;
            case "situationCivile":
                return <DropdownSituationCivile
                    key={key}
                    dropdownProps={{
                        disabled: !isEditionAllowed || !isProfileEditionEnabled,
                        onChange,
                        selectedKey
                    }}
                />;
            case "anneesNaissancesEnfants":
                return <PickerYear
                    key={key}
                    label={label}
                    pickerProps={{
                        disabled: !isEditionAllowed || !isProfileEditionEnabled,
                        id,
                        onChange
                    }}
                    years={anneesNaissancesEnfants}
                />;
            default:
                return <ProfileTextField
                    key={key}
                    textFieldProps={{
                        disabled: !isEditionAllowed || !isProfileEditionEnabled,
                        id,
                        label,
                        onChange: onChange || (_ => null),
                        value: value || ""
                    }}
                />;
        }
    };

    return <Page title="Mon profil">

        {isPasswordEditionEnabled
            ? <PasswordForm onCancel={togglePasswordEdition} onSave={togglePasswordEdition} />
            : <>
                <Stack styles={styles.fields}>

                    <Stack styles={styles.column}>
                        {fieldsLeftCol.map((field) => renderField(field))}
                    </Stack>

                    <Stack styles={styles.column}>
                        {fieldsRightCol.map((field) => renderField(field))}
                    </Stack>

                </Stack>

                <Preferences
                    consentementCollecteDonneesPersonnelles={newConsentementCollecteDonneesPersonnelles}
                    consentementDiffusionDonneesPersonnelles={newConsentementDiffusionDonneesPersonnelles}
                    enabled={isProfileEditionEnabled}
                    onChangeConsentementCollecteDonneesPersonnelles={(event, checked) => setNewConsentementCollecteDonneesPersonnelles(accessType === AccessType.prospect ? checked : true)} // Pas indispensable, sécurité supplémentaire
                    onChangeConsentementDiffusionDonneesPersonnelles={(event, checked) => setNewConsentementDiffusionDonneesPersonnelles(checked)}
                    onChangeSouhaiteRecevoirOffres={(event, checked) => setNewSouhaiteRecevoirOffres(checked)}
                    souhaiteRecevoirOffres={newSouhaiteRecevoirOffres}
                />

                <Stack styles={styles.buttons}>
                    {isProfileEditionEnabled && <>
                        <FormActionButton id="btnSave" src={saveIcon} text="Enregistrer mes modifications" onClick={saveProfile} primary />
                        <FormActionButton id="btnCancel" src={cancelIcon} text="Annuler mes modifications" onClick={toggleProfileEdition} />
                    </>}
                    {!isProfileEditionEnabled && <>
                        <FormActionButton id="btnEditProfile" src={userRedIcon} text="Modifier mes informations" onClick={toggleProfileEdition} />
                        <FormActionButton id="btnEditPassword" src={padlockRedIcon} text="Modifier mon mot de passe" onClick={togglePasswordEdition} />
                    </>}
                </Stack>
            </>
        }

    </Page>;

};

export default MonProfil;